<template>
  <div>
    <a href='https://www.eyemed.com' target='_blank' class="btn white --sm">visit eyemed.com</a>
  </div>
</template>
<script>
  import { isDev } from '@/utils'
  export default {
    methods: {
      isDev
    }
  }
</script>
